import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Link from 'next/link';
import Title from '../Shared/Title';
import { ISidebarTagsProps } from './interfaces';
import theme from '@src/theme';

const SidebarTags: React.FC<ISidebarTagsProps> = ({ tags }) => {
  return (
    <Flex direction="column" mt={6}>
      <Title>TAGS</Title>
      <Flex wrap="wrap">
        {tags?.map((tag) => (
          <Link
            key={tag?.slug?.current ?? ''}
            href={`/tag/${tag?.slug?.current}`}
            passHref
          >
            <Box
              color="grey.300"
              fontFamily={theme.fonts.montserrat}
              fontWeight="300"
              border="1px"
              borderColor="primary"
              borderStyle="solid"
              py="3px"
              px="5px"
              mr="5px"
              mb="10px"
              fontSize="14px"
              transitionProperty="all"
              transitionDuration="320ms"
              transitionTimingFunction="ease-in-out"
              cursor="pointer"
              _hover={{ bg: 'primary', color: 'white' }}
            >
              {tag?.title ?? ''}
            </Box>
          </Link>
        ))}
      </Flex>
    </Flex>
  );
};

export default SidebarTags;
